// Todays - Reservation Overview
export const TODAYS_RESERVATION_OVERVIEW_REQUEST = 'TODAYS_RESERVATION_OVERVIEW_REQUEST';
export const TODAYS_RESERVATION_OVERVIEW_SUCCESS = 'TODAYS_RESERVATION_OVERVIEW_SUCCESS';
export const TODAYS_RESERVATION_OVERVIEW_FAILURE = 'TODAYS_RESERVATION_OVERVIEW_FAILURE';

// Reservation Volume by Session
export const TODAYS_RESERVATION_VOLUME_BY_SESSION_REQUEST = 'TODAYS_RESERVATION_VOLUME_BY_SESSION_REQUEST';
export const TODAYS_RESERVATION_VOLUME_BY_SESSION_SUCCESS = 'TODAYS_RESERVATION_VOLUME_BY_SESSION_SUCCESS';
export const TODAYS_RESERVATION_VOLUME_BY_SESSION_FAILURE = 'TODAYS_RESERVATION_VOLUME_BY_SESSION_FAILURE';

// Assigned Reservation
export const TODAYS_ASSIGNED_RESERVATION_REQUEST = 'TODAYS_ASSIGNED_RESERVATION_REQUEST';
export const TODAYS_ASSIGNED_RESERVATION_SUCCESS = 'TODAYS_ASSIGNED_RESERVATION_SUCCESS';
export const TODAYS_ASSIGNED_RESERVATION_FAILURE = 'TODAYS_ASSIGNED_RESERVATION_FAILURE';

// Upcoming Reservation
export const TODAYS_UPCOMING_RESERVATION_REQUEST = 'TODAYS_UPCOMING_RESERVATION_REQUEST';
export const TODAYS_UPCOMING_RESERVATION_SUCCESS = 'TODAYS_UPCOMING_RESERVATION_SUCCESS';
export const TODAYS_UPCOMING_RESERVATION_FAILURE = 'TODAYS_UPCOMING_RESERVATION_FAILURE';

// Reservation Overview
export const UPCOMING_RESERVATION_OVERVIEW_REQUEST = 'UPCOMING_RESERVATION_OVERVIEW_REQUEST';
export const UPCOMING_RESERVATION_OVERVIEW_SUCCESS = 'UPCOMING_RESERVATION_OVERVIEW_SUCCESS';
export const UPCOMING_RESERVATION_OVERVIEW_FAILURE = 'UPCOMING_RESERVATION_OVERVIEW_FAILURE';

// Reservation Volume by Session
export const UPCOMING_RESERVATION_VOLUME_BY_SESSION_REQUEST = 'UPCOMING_RESERVATION_VOLUME_BY_SESSION_REQUEST';
export const UPCOMING_RESERVATION_VOLUME_BY_SESSION_SUCCESS = 'UPCOMING_RESERVATION_VOLUME_BY_SESSION_SUCCESS';
export const UPCOMING_RESERVATION_VOLUME_BY_SESSION_FAILURE = 'UPCOMING_RESERVATION_VOLUME_BY_SESSION_FAILURE';

// Reservation Volume
export const UPCOMING_RESERVATION_VOLUME_REQUEST = 'UPCOMING_RESERVATION_VOLUME_REQUEST';
export const UPCOMING_RESERVATION_VOLUME_SUCCESS = 'UPCOMING_RESERVATION_VOLUME_SUCCESS';
export const UPCOMING_RESERVATION_VOLUME_FAILURE = 'UPCOMING_RESERVATION_VOLUME_FAILURE';

// Reservation by Session
export const UPCOMING_RESERVATION_BY_SESSION_REQUEST = 'UPCOMING_RESERVATION_BY_SESSION_REQUEST';
export const UPCOMING_RESERVATION_BY_SESSION_SUCCESS = 'UPCOMING_RESERVATION_BY_SESSION_SUCCESS';
export const UPCOMING_RESERVATION_BY_SESSION_FAILURE = 'UPCOMING_RESERVATION_BY_SESSION_FAILURE';

// Reservation Status by Date
export const UPCOMING_RESERVATION_STATUS_BY_DATE_REQUEST = 'UPCOMING_RESERVATION_STATUS_BY_DATE_REQUEST';
export const UPCOMING_RESERVATION_STATUS_BY_DATE_SUCCESS = 'UPCOMING_RESERVATION_STATUS_BY_DATE_SUCCESS';
export const UPCOMING_RESERVATION_STATUS_BY_DATE_FAILURE = 'UPCOMING_RESERVATION_STATUS_BY_DATE_FAILURE';

// Cancellation by Reasons
export const UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_REQUEST = 'UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_REQUEST';
export const UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_SUCCESS = 'UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_SUCCESS';
export const UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_FAILURE = 'UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_FAILURE';

// Upcoming Reservation Details
export const UPCOMING_RESERVATION_DETAILS_REQUEST = 'UPCOMING_RESERVATION_DETAILS_REQUEST';
export const UPCOMING_RESERVATION_DETAILS_SUCCESS = 'UPCOMING_RESERVATION_DETAILS_SUCCESS';
export const UPCOMING_RESERVATION_DETAILS_FAILURE = 'UPCOMING_RESERVATION_DETAILS_FAILURE';

// Reservation Overview
export const RESERVATION_OVERVIEW_REQUEST = 'RESERVATION_OVERVIEW_REQUEST';
export const RESERVATION_OVERVIEW_SUCCESS = 'RESERVATION_OVERVIEW_SUCCESS';
export const RESERVATION_OVERVIEW_FAILURE = 'RESERVATION_OVERVIEW_FAILURE';

// Slot Wise Reservation
export const RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_REQUEST = 'RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_REQUEST';
export const RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_SUCCESS = 'RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_SUCCESS';
export const RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_FAILURE = 'RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_FAILURE';

// Daily Reservations & Guests
export const RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_REQUEST = 'RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_REQUEST';
export const RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_SUCCESS = 'RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_SUCCESS';
export const RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_FAILURE = 'RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_FAILURE';

// Dine-in Duration By Groups
export const RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_REQUEST = 'RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_REQUEST';
export const RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_SUCCESS = 'RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_SUCCESS';
export const RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_FAILURE = 'RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_FAILURE';

// Guest Size Distribution
export const RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_REQUEST = 'RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_REQUEST';
export const RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_SUCCESS = 'RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_SUCCESS';
export const RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_FAILURE = 'RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_FAILURE';

// Reservation Details
export const RESERVATION_OVERVIEW_DETAILS_REQUEST = 'RESERVATION_OVERVIEW_DETAILS_REQUEST';
export const RESERVATION_OVERVIEW_DETAILS_SUCCESS = 'RESERVATION_OVERVIEW_DETAILS_SUCCESS';
export const RESERVATION_OVERVIEW_DETAILS_FAILURE = 'RESERVATION_OVERVIEW_DETAILS_FAILURE';

// Reservation Overview
export const RESERVATION_TREND_OVERVIEW_REQUEST = 'RESERVATION_TREND_OVERVIEW_REQUEST';
export const RESERVATION_TREND_OVERVIEW_SUCCESS = 'RESERVATION_TREND_OVERVIEW_SUCCESS';
export const RESERVATION_TREND_OVERVIEW_FAILURE = 'RESERVATION_TREND_OVERVIEW_FAILURE';

// Reservation Trend
export const RESERVATION_TREND_REQUEST = 'RESERVATION_TREND_REQUEST';
export const RESERVATION_TREND_SUCCESS = 'RESERVATION_TREND_SUCCESS';
export const RESERVATION_TREND_FAILURE = 'RESERVATION_TREND_FAILURE';

// Reservation Trend by Groups
export const RESERVATION_TREND_BY_GROUPS_REQUEST = 'RESERVATION_TREND_BY_GROUPS_REQUEST';
export const RESERVATION_TREND_BY_GROUPS_SUCCESS = 'RESERVATION_TREND_BY_GROUPS_SUCCESS';
export const RESERVATION_TREND_BY_GROUPS_FAILURE = 'RESERVATION_TREND_BY_GROUPS_FAILURE';

// Reservation Trend by Avg Wait Time
export const RESERVATION_TREND_BY_AVG_WAIT_TIME_REQUEST = 'RESERVATION_TREND_BY_AVG_WAIT_TIME_REQUEST';
export const RESERVATION_TREND_BY_AVG_WAIT_TIME_SUCCESS = 'RESERVATION_TREND_BY_AVG_WAIT_TIME_SUCCESS';
export const RESERVATION_TREND_BY_AVG_WAIT_TIME_FAILURE = 'RESERVATION_TREND_BY_AVG_WAIT_TIME_FAILURE';

// Customer Trend
export const RESERVATION_TREND_CUSTOMER_TREND_REQUEST = 'RESERVATION_TREND_CUSTOMER_TREND_REQUEST';
export const RESERVATION_TREND_CUSTOMER_TREND_SUCCESS = 'RESERVATION_TREND_CUSTOMER_TREND_SUCCESS';
export const RESERVATION_TREND_CUSTOMER_TREND_FAILURE = 'RESERVATION_TREND_CUSTOMER_TREND_FAILURE';

// Customer Visits
export const RESERVATION_TREND_CUSTOMER_VISITS_REQUEST = 'RESERVATION_TREND_CUSTOMER_VISITS_REQUEST';
export const RESERVATION_TREND_CUSTOMER_VISITS_SUCCESS = 'RESERVATION_TREND_CUSTOMER_VISITS_SUCCESS';
export const RESERVATION_TREND_CUSTOMER_VISITS_FAILURE = 'RESERVATION_TREND_CUSTOMER_VISITS_FAILURE';

export const UPCOMING_RESERVATION_START_DATE_CHANGE = 'UPCOMING_RESERVATION_START_DATE_CHANGE';
export const UPCOMING_RESERVATION_END_DATE_CHANGE = 'UPCOMING_RESERVATION_END_DATE_CHANGE';


